import { supabase } from "./supabase";
import { fromDbHsseq, toDbHsseqUpsert } from "../lib/mappers";

const HSSEQ_COLUMNS = "id, dpr_id, category, details";

const listHsseq = async (dprId) => {
  const { data, error } = await supabase
    .from("hsseq_entries")
    .select(HSSEQ_COLUMNS)
    .eq("dpr_id", dprId);

  if (error) throw error;
  return (data ?? []).map(fromDbHsseq);
};

const upsertHsseq = async (entries) => {
  if (!entries.length) return [];
  const payload = entries.map(toDbHsseqUpsert);

  const { data, error } = await supabase
    .from("hsseq_entries")
    .upsert(payload, { onConflict: "dpr_id,category" })
    .select(HSSEQ_COLUMNS);

  if (error) throw error;
  return (data ?? []).map(fromDbHsseq);
};

export { listHsseq, upsertHsseq };
